/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetMapsTokenResponseFromDiscriminatorValue, type ErrorResponse, type GetMapsTokenResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/maps/token
 */
export interface TokenRequestBuilder extends BaseRequestBuilder<TokenRequestBuilder> {
    /**
     * Returns a short-lived access token for the admin map control. Request a new one when it expires.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetMapsTokenResponse>}
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 503 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<GetMapsTokenResponse | undefined>;
    /**
     * Returns a short-lived access token for the admin map control. Request a new one when it expires.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const TokenRequestBuilderUriTemplate = "{+baseurl}/api/maps/token";
/**
 * Metadata for all the requests in the request builder.
 */
export const TokenRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: TokenRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            503: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetMapsTokenResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
